export var DOMAINS;
(function (DOMAINS) {
    DOMAINS["SPICYCHAT"] = "spicychat.ai";
    DOMAINS["PIXELCHAT"] = "pixelchat.ai";
    DOMAINS["SECRETMATE"] = "app.secretmate.ai";
    DOMAINS["ADULTTIME"] = "roleplay.adulttime.com";
    DOMAINS["EVIL_ANGEL"] = "roleplay.evilangel.com";
    DOMAINS["ASG_MAX"] = "roleplay.asgmax.com";
})(DOMAINS || (DOMAINS = {}));
const SPICYCHAT_APPLICATION_ID = "spicychat";
const PIXELCHAT_APPLICATION_ID = "pixelchat";
const SECRETMATE_APPLICATION_ID = "secretmate";
const ADULTTIME_APPLICATION_ID = "adulttime_application";
const EVIL_ANGEL_APPLICATION_ID = "evil_angel";
const ASG_MAX_APPLICATION_ID = "asg_max";
export const THIRD_PARTY_APP_IDS = [ADULTTIME_APPLICATION_ID, EVIL_ANGEL_APPLICATION_ID, ASG_MAX_APPLICATION_ID];
export const ISPARTNER_LOCALSTORAGE_KEY = "isPartner";
export const JWT_LOCAL_STORAGE_KEY = "jwt";
export const EXTERNAL_USERNAME_KEY = "externalUsername";
export var APPLICATIONS_ID;
(function (APPLICATIONS_ID) {
    APPLICATIONS_ID["SpicyChat"] = "spicychat";
    APPLICATIONS_ID["PixelChat"] = "pixelchat";
    APPLICATIONS_ID["SecretMate"] = "secretmate";
    APPLICATIONS_ID["AdultTime"] = "adulttime_application";
    APPLICATIONS_ID["EvilAngel"] = "evil_angel";
    APPLICATIONS_ID["AsgMax"] = "asg_max";
})(APPLICATIONS_ID || (APPLICATIONS_ID = {}));
export var APPLICATIONS_NAME;
(function (APPLICATIONS_NAME) {
    APPLICATIONS_NAME["SPICYCHAT"] = "SpicyChat";
    APPLICATIONS_NAME["PIXELCHAT"] = "PixelChat";
    APPLICATIONS_NAME["SECRETMATE"] = "SecretMate";
    APPLICATIONS_NAME["ADULTTIME"] = "AdultTime";
    APPLICATIONS_NAME["EVIL_ANGEL"] = "EvilAngel";
    APPLICATIONS_NAME["ASG_MAX"] = "AsgMax";
})(APPLICATIONS_NAME || (APPLICATIONS_NAME = {}));
export class ApplicationDefinition {
    id;
    name;
    domain;
    testDomains;
    constructor(id, name, domain, testDomains) {
        this.id = id;
        this.name = name;
        this.domain = domain;
        this.testDomains = testDomains;
    }
    isNextDayApp() {
        return this.id === APPLICATIONS_ID.SpicyChat || this.id === APPLICATIONS_ID.PixelChat || this.id === APPLICATIONS_ID.SecretMate;
    }
    isPartnerApp() {
        return !this.isNextDayApp();
    }
    hasDomain(domain) {
        if (this.domain === domain) {
            return true;
        }
        for (const domainToTest of this.testDomains) {
            if (domain === domainToTest) {
                return true;
            }
        }
        return false;
    }
    isParentDomainFor(domain) {
        if (this.domain === domain) {
            return true;
        }
        for (const domainToTest of this.testDomains) {
            if (domain.includes(domainToTest)) {
                return true;
            }
        }
        return false;
    }
}
export const APP_NAME_TO_DEF = new Map([
    [
        APPLICATIONS_NAME.SPICYCHAT,
        new ApplicationDefinition(APPLICATIONS_ID.SpicyChat, APPLICATIONS_NAME.SPICYCHAT, DOMAINS.SPICYCHAT, [
            "spicychat-frontend.pages.dev",
            "uat.spicychat-frontend.pages.dev",
            "staging.spicychat-frontend.pages.dev",
            "dev.spicychat-frontend.pages.dev",
            "beta.spicychat-frontend.pages.dev",
            "next-platform-web-test.pages.dev",
            "e2e.spicychat-frontend.pages.dev",
            "spicychat-frontend-e2e.pages.dev",
        ]),
    ],
    [
        APPLICATIONS_NAME.PIXELCHAT,
        new ApplicationDefinition(APPLICATIONS_ID.PixelChat, APPLICATIONS_NAME.PIXELCHAT, DOMAINS.PIXELCHAT, [
            "spicychat-frontend-e3i.pages.dev",
            "uat.spicychat-frontend-e3i.pages.dev",
            "staging.spicychat-frontend-e3i.pages.dev",
            "dev.spicychat-frontend-e3i.pages.dev",
        ]),
    ],
    [
        APPLICATIONS_NAME.SECRETMATE,
        new ApplicationDefinition(APPLICATIONS_ID.SecretMate, APPLICATIONS_NAME.SECRETMATE, DOMAINS.SECRETMATE, [
            "dev.secretmate.ai",
            "uat.secretmate.ai",
            "secretmate.pages.dev",
            "dev.secretmate.pages.dev",
            "uat.secretmate.pages.dev",
            "staging.secretmate.pages.dev",
        ]),
    ],
    [
        APPLICATIONS_NAME.ADULTTIME,
        new ApplicationDefinition(APPLICATIONS_ID.AdultTime, APPLICATIONS_NAME.ADULTTIME, DOMAINS.ADULTTIME, [
            "roleplay-adulttime.spicychat-frontend.pages.dev",
            "white_labeling.spicychat-frontend.pages.dev",
        ]),
    ],
    [
        APPLICATIONS_NAME.ASG_MAX,
        new ApplicationDefinition(APPLICATIONS_ID.AsgMax, APPLICATIONS_NAME.ASG_MAX, DOMAINS.ASG_MAX, [
            "roleplay-asgmax.spicychat-frontend.pages.dev",
            "white_labeling.spicychat-frontend.pages.dev",
        ]),
    ],
    [
        APPLICATIONS_NAME.EVIL_ANGEL,
        new ApplicationDefinition(APPLICATIONS_ID.EvilAngel, APPLICATIONS_NAME.EVIL_ANGEL, DOMAINS.EVIL_ANGEL, [
            "roleplay-evilangel.spicychat-frontend.pages.dev",
            "white_labeling.spicychat-frontend.pages.dev",
        ]),
    ],
]);
// TODO(sebastian): [NX-8947] Keys below are intentionally lowercase because consumers index these enums at runtime using `APPLICATIONS_ID` values (`"spicychat"`, `"pixelchat"`, `"secretmate"`). Renaming the keys requires updating every `LEGAL_PAGES_X[applicationId as keyof typeof LEGAL_PAGES_X]` call site — out of scope for this PR.
/* eslint-disable @typescript-eslint/naming-convention -- enum keys must match `APPLICATIONS_ID` string values for runtime lookup; see TODO above. */
export var LEGAL_PAGES_APP_NAMES;
(function (LEGAL_PAGES_APP_NAMES) {
    LEGAL_PAGES_APP_NAMES["spicychat"] = "SpicyChat.AI";
    LEGAL_PAGES_APP_NAMES["pixelchat"] = "PixelChat.AI";
    LEGAL_PAGES_APP_NAMES["secretmate"] = "SecretMate.AI";
})(LEGAL_PAGES_APP_NAMES || (LEGAL_PAGES_APP_NAMES = {}));
export const LEGAL_PAGES_SUPPORT_EMAILS = {
    spicychat: "support@spicychat.ai",
    pixelchat: "support@pixelchat.ai",
    secretmate: "support@secretmate.ai",
};
export var LEGAL_PAGES_WEBSITE_URLS;
(function (LEGAL_PAGES_WEBSITE_URLS) {
    LEGAL_PAGES_WEBSITE_URLS["spicychat"] = "https://www.spicychat.ai";
    LEGAL_PAGES_WEBSITE_URLS["pixelchat"] = "https://www.pixelchat.ai";
    LEGAL_PAGES_WEBSITE_URLS["secretmate"] = "https://www.secretmate.ai";
})(LEGAL_PAGES_WEBSITE_URLS || (LEGAL_PAGES_WEBSITE_URLS = {}));
/* eslint-enable @typescript-eslint/naming-convention -- end exception for legal-page enums; restore default naming-convention enforcement for the rest of the file. */
export const LOAD_APP_AS_KEY = "load-app-as";
export const LOAD_APP_AS_KEY_INITIAL = "load-app-as-initial";
